<template>
    <ComingSoon />

</template>
<script>
import ComingSoon from '../comingSoon.vue'
export default {
  components: {
    ComingSoon
  }
}
</script>
